// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__1mvLf","footer":"ReportModalFilter_footer__3FeY1"};